import type { ReactNode } from 'react';
import { Banner } from '@/shared/ui/banner';
import { Button } from '@/shared/ui/button';

type ConfirmBannerProps = {
  id: string;
  title: string;
  children: ReactNode;
  keepLabel: string;
  confirmLabel: string;
  isConfirming: boolean;
  onKeep: () => void;
  onConfirm: () => void;
};

/** An inline confirm for a destructive action: keep is the safe default, confirm is the danger button. */
export function ConfirmBanner({
  id,
  title,
  children,
  keepLabel,
  confirmLabel,
  isConfirming,
  onKeep,
  onConfirm,
}: ConfirmBannerProps) {
  return (
    <div role="alertdialog" aria-labelledby={id}>
      <Banner
        tone="bad"
        id={id}
        title={title}
        action={
          <div className="flex gap-2">
            <Button onClick={onKeep}>{keepLabel}</Button>
            <Button variant="danger" isLoading={isConfirming} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        }
      >
        {children}
      </Banner>
    </div>
  );
}
